import routeControlPointService from "../shared/services/routeControlPointService";

const REQUEST_CREATE_ROUTE_CONTROL_POINT = "REQUEST_CREATE_ROUTE_CONTROL_POINT";
const RESPONSE_CREATE_ROUTE_CONTROL_POINT = "RESPONSE_CREATE_ROUTE_CONTROL_POINT";
const REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE = "REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE";

const requestCreateRouteControlPointAction = () => {
  return {
    type: REQUEST_CREATE_ROUTE_CONTROL_POINT,
  };
};

const responseCreateRouteControlPointAction = (data) => {
  return {
    type: RESPONSE_CREATE_ROUTE_CONTROL_POINT,
    data,
  };
};

const requestCreateRouteControlPointFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE,
    errors,
  };
};

const createRouteControlPoint = (options) => {
  return (dispatch) => {
    dispatch(requestCreateRouteControlPointAction());

    routeControlPointService
      .createRouteControlPoint({ routeId: options.route.id, controlPointId: options.controlPoint.id, number: options.number })
      .then((result) => {
        dispatch(responseCreateRouteControlPointAction(options));
      })
      .catch((error) => {
        dispatch(requestCreateRouteControlPointFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_ROUTE_CONTROL_POINT = "REQUEST_DELETE_ROUTE_CONTROL_POINT";
const RESPONSE_DELETE_ROUTE_CONTROL_POINT = "RESPONSE_DELETE_ROUTE_CONTROL_POINT";
const REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE = "REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE";

const requestDeleteRouteControlPointAction = () => {
  return {
    type: REQUEST_DELETE_ROUTE_CONTROL_POINT,
  };
};

const responseDeleteRouteControlPointAction = (data) => {
  return {
    type: RESPONSE_DELETE_ROUTE_CONTROL_POINT,
    data,
  };
};

const requestDeleteRouteControlPointFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE,
    errors,
  };
};

const deleteRouteControlPoint = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteRouteControlPointAction());

    routeControlPointService
      .deleteRouteControlPoint({ routeId: options.route.id, controlPointId: options.controlPoint.id })
      .then((result) => {
        dispatch(responseDeleteRouteControlPointAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteRouteControlPointFailureAction(error.response));
      });
  };
};

export {
  REQUEST_CREATE_ROUTE_CONTROL_POINT,
  RESPONSE_CREATE_ROUTE_CONTROL_POINT,
  REQUEST_CREATE_ROUTE_CONTROL_POINT_FAILURE,
  createRouteControlPoint,
  REQUEST_DELETE_ROUTE_CONTROL_POINT,
  RESPONSE_DELETE_ROUTE_CONTROL_POINT,
  REQUEST_DELETE_ROUTE_CONTROL_POINT_FAILURE,
  deleteRouteControlPoint,
};
